<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up flex_box com_pop" style="display: block">
        <div class="pop_tit _flex">
            <div class="report_title_wrap">
                <p>시민제보 상태 수정</p>
                <div class="btns">
                    <button v-if="$props.prevInfo && $props.prevInfo.idx" class="table_btn _blue" @click="getPrevInfo($props.prevInfo.idx)">
                        이전
                    </button>
                    <button v-if="$props.nextInfo && $props.nextInfo.idx" class="table_btn _blue" @click="getNextInfo($props.nextInfo.idx)">
                        다음
                    </button>
                </div>
            </div>
            <button class="close_btn icon_wrap">
                <img src="img/close.png" @click="closeModal" alt="닫기" />
            </button>
        </div>
        <div class="report_modal">
            <div class="_flex parts">
                <div class="left_part result_form">
                    <ul>
                        <li class="tag_wrap">
                            <span class="tag_gray">{{ state.data.state === 1 ? "대기중" : "접수완료" }}</span>
                            <span class="tag_red" v-if="state.data.type === 1">
                                {{ state.data.isSchool === 0 ? "학교 주변 외" : "학교 주변" }}
                            </span>
                            <span class="tag_red" v-else>{{ strAdType(state.data.adType) }}</span>
                        </li>

                        <li>
                            <span class="form_li_tit">제보자 닉네임</span>
                            <span>{{ state.data.nickname != null ? state.data.nickname : "익명" }}</span>
                        </li>
                        <li>
                            <span class="form_li_tit">업소명</span>
                            <span>{{ state.data.shopName }}</span>
                        </li>
                        <li>
                            <span class="form_li_tit">업소주소</span>
                            <span>
                                {{ state.data.address }}
                                <br />
                                {{ state.data.addressDetail }}
                            </span>
                        </li>
                        <li class="li_con">
                            <span class="form_li_tit">업소 전화번호</span>
                            <span>{{ state.data.number }}</span>
                        </li>
                        <li class="li_con">
                            <span class="form_li_tit">업소 URL</span>

                            <a href="#" class="underline" @click.prevent="openUrl(state.data.adUrl)">
                                {{ state.data.adUrl }}
                            </a>
                        </li>
                        <li class="">
                            <label for="con" class="form_li_tit">내용</label>
                            <textarea name="" id="con" class="custom_scroll h_270" disabled v-model="state.data.content"></textarea>
                        </li>
                        <li class="file_wrap">
                            <span class="form_li_tit">첨부</span>
                            <ul class="custom_scroll">
                                <template v-if="state.data.fileList != null && state.data.fileList.length > 0">
                                    <li style="gap: 0 !important" v-for="item in state.data.fileList" :key="item.idx">
                                        <a :href="item.file" class="down underline" target="_blank">
                                            {{ item.imgRealName }}
                                        </a>

                                        <button
                                            class="downIcon"
                                            type="button"
                                            @click.prevent.stop="downloadFile(item.file, item.imgRealName)"
                                            style="margin-left: 5px"
                                        >
                                            <img src="img/download.png" alt="다운로드" />
                                        </button>
                                    </li>
                                </template>
                                <li v-else>등록된 파일이 없습니다.</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="right_part">
                    <ul class="result_form">
                        <li class="radio_wrap">
                            <span class="form_li_tit">게시글 상태</span>
                            <div class="input_wrap _flex _column">
                                <label for="chk1_yes">
                                    <input type="radio" name="chk1" id="chk1_yes" value="1" v-model="state.data.state" />
                                    <em></em>
                                    <span>대기중</span>
                                </label>
                                <label for="chk1_no">
                                    <input type="radio" name="chk1" id="chk1_no" value="2" v-model="state.data.state" />
                                    <em></em>
                                    <span>접수완료</span>
                                </label>
                            </div>
                        </li>
                        <template v-if="state.data.state == 2">
                            <li class="">
                                <span class="form_li_tit">업종분류</span>
                                <div class="select_tab_box_wrap w_100">
                                    <div class="select_tab_box">
                                        <div
                                            class="selected_tab"
                                            :class="{ active: state.isShowCategoryType }"
                                            @click="state.isShowCategoryType = !state.isShowCategoryType"
                                        >
                                            <span>{{ state.detailTxt }}</span>
                                        </div>
                                        <div class="tab_option" v-show="state.isShowCategoryType" :class="{ active: state.isShowCategoryType }">
                                            <button
                                                @click="
                                                    state.categoryType = 0;
                                                    state.detailTxt = '전체';
                                                    state.isShowCategoryType = false;
                                                "
                                            >
                                                전체
                                            </button>

                                            <button
                                                v-for="item in state.categoryList"
                                                :key="item.caIdx"
                                                @click="
                                                    state.categoryType = item.caIdx;
                                                    state.detailTxt = item.caName;
                                                    state.isShowCategoryType = false;
                                                "
                                            >
                                                {{ item.caName }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <hr />
                            <li class="radio_wrap">
                                <span class="form_li_tit">고발 / 신고</span>
                                <div class="input_wrap _flex _column w_100">
                                    <label for="chk2_yes">
                                        <input
                                            type="radio"
                                            name="chk2"
                                            id="chk2_yes"
                                            value="1"
                                            :checked="state.data.isReport == 1"
                                            @change="state.data.isReport = 1"
                                        />
                                        <em></em>
                                        <span>가능</span>
                                    </label>
                                    <template v-if="state.data.isReport == 1">
                                        <div class="select_tab_box_wrap w_100 select_list">
                                            <div class="select_tab_box">
                                                <div
                                                    class="selected_tab"
                                                    :class="{ active: state.isShowreportState }"
                                                    @click="state.isShowreportState = !state.isShowreportState"
                                                >
                                                    <span>{{ state.reportStateTxt }}</span>
                                                </div>
                                                <div class="tab_option" v-show="state.isShowreportState">
                                                    <button
                                                        v-for="value in selectOption.reportType"
                                                        type="button"
                                                        @click="
                                                            state.data.reportState = value.id;
                                                            state.reportStateTxt = value.name;
                                                            state.isShowreportState = false;
                                                        "
                                                        @change="state.data.reportState = value.id"
                                                    >
                                                        {{ value.name }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-if="state.data.reportState == 1">
                                            <div class="select_tab_box_wrap w_100 select_list">
                                                <div class="select_tab_box">
                                                    <div
                                                        class="selected_tab"
                                                        :class="{ active: state.isShowReportType }"
                                                        @click="state.isShowReportType = !state.isShowReportType"
                                                    >
                                                        <span>{{ state.reportTypeTxt }}</span>
                                                    </div>
                                                    <div class="tab_option" v-show="state.isShowReportType">
                                                        <button
                                                            v-for="value in selectOption.report"
                                                            type="button"
                                                            @click="
                                                                state.data.reportType = value.id;
                                                                state.reportTypeTxt = value.name;
                                                                state.isShowReportType = false;
                                                            "
                                                            @change="state.data.reportType = value.id"
                                                        >
                                                            {{ value.name }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <input
                                                type="text"
                                                class="select_type_text"
                                                v-model="state.data.reportMemo"
                                                placeholder="내용을 입력하세요"
                                            />
                                        </template>
                                    </template>

                                    <label for="chk2_no">
                                        <input
                                            type="radio"
                                            name="chk2"
                                            id="chk2_no"
                                            value="2"
                                            :checked="state.data.isReport == 2"
                                            @change="state.data.isReport = 2"
                                        />
                                        <em></em>
                                        <span>불가능</span>
                                    </label>

                                    <template v-if="state.data.isReport == 2">
                                        <div class="select_tab_box_wrap w_100">
                                            <div class="select_tab_box">
                                                <div
                                                    class="selected_tab"
                                                    :class="{ active: state.isShowReportReasonType }"
                                                    @click="state.isShowReportReasonType = !state.isShowReportReasonType"
                                                >
                                                    <span>{{ state.reportReasonTxt }}</span>
                                                </div>
                                                <div class="tab_option" v-show="state.isShowReportReasonType">
                                                    <button
                                                        v-for="value in selectOption.unReport"
                                                        type="button"
                                                        @click="
                                                            state.data.reason = value.id;
                                                            state.reportReasonTxt = value.name;
                                                            state.isShowReportReasonType = false;
                                                        "
                                                        @change="state.data.reason = value.id"
                                                    >
                                                        {{ value.name }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </li>
                        </template>
                        <hr />
                        <li class="">
                            <label for="memo" class="form_li_tit">메모</label>
                            <textarea
                                name=""
                                id="memo"
                                class="custom_scroll h_127"
                                v-model="state.data.memo"
                                placeholder="메모 내용을 입력해주세요"
                            ></textarea>
                        </li>
                    </ul>
                </div>
            </div>
            <Comment :idx="state.data.idx" :type="state.data.type"></Comment>
        </div>
        <div class="_flex _center btn_wrap" style="margin-top: 20px">
            <button class="submit_btn _130 _main_blue" @click="save(state.data.type)">저장</button>
        </div>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal2"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts">
    import { onMounted, reactive, onUnmounted, CommonUtils, apiService, types, ModalDefault, watch, Comment } from "@/BaseComponent";

    export default {
        props: {
            reportInfo: {
                type: Object,
                defalut: {},
            },
            nextInfo: {
                type: Object,
                defalut: {},
            },
            prevInfo: {
                type: Object,
                defalut: {},
            },
        },
        emits: ["close", "save", "prev", "next"],
        components: { ModalDefault, Comment },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                data: {} as any,
                next: {},
                prev: {},

                reportStateTxt: "신고" as string,
                reportTypeTxt: "국민신문고" as string,
                reportReasonTxt: "내용 부족" as string,

                detailTxt: "전체" as string,
                categoryList: [] as Array<any>,
                categoryType: 0 as number,

                isShowCategoryType: false as boolean, // 업종분류 리스트
                isShowreportState: false as boolean,
                isShowReportType: false as boolean, // 가능 > 신고일 때, 신고 리스트
                isShowReportReasonType: false as boolean, // 불가능

                // reportState: 1 as number, // 신고/고발
                isShowReportPossibleList: false as boolean, // 가능, 신고 일 때 리스트
                isShowReportImpossibleList: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const selectOption = {
                reportType: [
                    { id: 1, name: "신고" },
                    { id: 2, name: "고발" },
                ],
                report: [
                    { id: 1, name: "국민신문고" },
                    { id: 2, name: "방통위" },
                    { id: 3, name: "기타" },
                ],
                unReport: [
                    { id: 1, name: "내용 부족" },
                    { id: 2, name: "주소 불명확" },
                    { id: 3, name: "온라인 모니터링 불가" },
                    { id: 4, name: "게시판 오신고" },
                    { id: 5, name: "중복" },
                    { id: 6, name: "기타" },
                ],
            };

            onMounted(async () => {
                await getCategoryList();

                if (props.reportInfo) {
                    state.data = props.reportInfo;
                    const match = state.categoryList.find((item) => item.caIdx === state.data.gubun);
                    const match2 = selectOption.reportType.find((item) => item.id === state.data.reportState);
                    const match3 = selectOption.report.find((item) => item.id === state.data.reportType);
                    const match4 = selectOption.unReport.find((item) => item.id === state.data.reason);

                    if (match) {
                        state.categoryType = match.caIdx;
                        state.detailTxt = match.caName;
                    } else {
                        state.categoryType = 0;
                        state.detailTxt = "전체";
                    }

                    if (match2) {
                        state.reportStateTxt = match2.name;
                    } else {
                        state.data.reportState = selectOption.reportType[0].id;
                        state.reportStateTxt = selectOption.reportType[0].name;
                    }

                    if (match3) {
                        state.reportTypeTxt = match3.name;
                    } else {
                        state.data.reportType = selectOption.report[0].id;
                        state.reportTypeTxt = selectOption.report[0].name;
                    }

                    if (match4) {
                        state.reportReasonTxt = match4.name;
                    } else {
                        state.data.reason = selectOption.unReport[0].id;
                        state.reportReasonTxt = selectOption.unReport[0].name;
                    }
                }
            });

            watch(
                () => props.reportInfo,
                () => {
                    if (props.reportInfo) {
                        state.data = props.reportInfo;
                    }
                },
                { deep: true },
            );

            const closeModal = () => {
                emit("close");
            };

            const save = (type: number) => {
                const param: types.ReqReportForAnswer = {
                    idx: state.data.idx,
                    state: state.data.state, // 상태 (1: 대기중 2: 접수완료)
                    gubun: state.categoryType, // 업종분류
                    isReport: state.data.isReport, // 고발신고여부 (1:가능 2: 불가능)
                    reportState: state.data.reportState, // 고발신고여부 > 가능 (1:신고 2: 고발)
                    reportType: state.data.reportType, // 고발신고여부 > 가능 > 신고 (1: 국민신문고 2:방통위 3:기타)
                    reportMemo: state.data.reportMemo, // 고발신고여부 > 가능 > 고발 (고발 사유)
                    reason: state.data.reason, // 고발신고여부 > 불가능 (1:내용 부족, 2: 주소 불명확, 3:온라인 모니터링 불가, 4:게시판 오신고, 5: 중복, 6:기타")
                    memo: state.data.memo, // 메모
                };
                emit("save", type, param);
            };

            const getCategoryList = async () => {
                const res = await apiService.category.list();

                if (res.returnCode === 0) {
                    state.categoryList = res.data;
                }
            };

            const openUrl = (url: string) => {
                if (!url) return;
                const link = /^https?:\/\//.test(url) ? url : "https://" + url;
                window.open(link, "_blank");
            };

            const downloadFile = async (file: string, imgName: string) => {
                if (!file) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "올바른 파일이 아닙니다.";
                    state.isShowModal = true;
                } else {
                    const res = await fetch(file);
                    const blob = await res.blob();
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = imgName;
                    link.click();
                    URL.revokeObjectURL(link.href);
                }
            };

            const closeModal2 = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const callBackModal = async (param: any) => {};

            const strAdType = (val: number) => {
                switch (val) {
                    case 1:
                        return "온라인 알선 광고";
                    case 2:
                        return "지면 광고";
                    case 3:
                        return "불법 옥외광고물";
                    default:
                        return "기타";
                }
            };
            const getPrevInfo = (idx: number) => {
                emit("prev", idx);
            };
            const getNextInfo = (idx: number) => {
                emit("next", idx);
            };

            return {
                state,
                closeModal,
                CommonUtils,
                save,
                openUrl,
                downloadFile,
                getCategoryList,
                closeModal2,
                callBackModal,
                strAdType,
                selectOption,
                getPrevInfo,
                getNextInfo,
            };
        },
    };
</script>
<style scoped>
    .downIcon img {
        width: 16px;
        height: 16px;
        object-fit: contain;
        display: inline-block;
        margin-left: 5px;
        transition: 0.3s;
        margin-bottom: 3px;
    }
    .report_modal .result_form .form_li_tit {
        min-width: 95px;
    }

    .tab_option {
        z-index: 999;
    }
    .select_tab_box {
        z-index: unset;
    }

    .result_form textarea.custom_scroll.h_270 {
        max-height: 20vh;
    }
    .result_form .file_wrap ul {
        height: 5vh;
        overflow-y: auto;
        width: 100%;
    }

    .result_form .down {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .report_title_wrap {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
    .report_title_wrap > .btns {
        display: flex;
        flex-direction: row;
        gap: 5px;
    }
</style>
